module.exports = __webpack_public_path__ + "img/exitParliament.61a5d45f.jpg";